import { gql } from '@apollo/client';

export const UPDATE_ASSESSMENT = gql`
  mutation updateAssessment($data: UpdateAssessmentInput!) {
    updateAssessment(data: $data) {
      id
    }
  }
`;
